import React from 'react';
import Flatpickr from 'react-flatpickr';

class FacilityMessages extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			editing: false,
			loading: false,
			verbiage: ""
		}
	}

	edit = (message) => (e) => {
		this.setState({ editing: message, loading: false, verbiage: this.props.data.FacilityMessages[message] })
	}
	editVerbiage = (e) => {
		this.setState({ verbiage: e.target.value });
	}
	cancel = (e) => {
		this.setState({ editing: false, loading: false })
	}
	confirmEdit = (e) => {
		this.setState({ loading: true });
		this.props.ws.send(JSON.stringify({ route: 'editFacilityMessage', message: this.state.editing, verbiage: this.state.verbiage }))
	}

	checkEnter = (e) => {
		if (e.keyCode === 13) {
			this.confirmEdit()
		}
	}

	componentDidUpdate(prevProps) {
		if (this.state.loading) {
			this.cancel()
		}
	}

	render() {
		if (this.props.active) {
			var fmList = []
			for (var message in this.props.data.FacilityMessages) {
				fmList.push(
					<div className="dataRow" key={message} onClick={this.edit(message)}>
						<span style={{ flex: '0 0 100px', textAlign: 'center' }}>{message}</span>
						<span style={{ flex: '1 0 20%' }}>{this.props.data.FacilityMessages[message]}</span>
					</div>
				)
			}

			var editMessage = ""
			if (this.state.editing) {
				editMessage = (
					<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
						<div className="pop">
							<div className="viewCloser" onClick={this.cancel}></div>
							<div>You Are Editing Message {this.state.editing}</div>
							<br />
							<div className="snazzyInputBox">
								<textarea className="bigTextInput" required value={this.state.verbiage} onChange={this.editVerbiage} ></textarea>
								<label className="textLabel">Message Verbiage</label>
							</div>
							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmEdit}>Confirm Message</div>}
						</div>
					</div>
				)
			}


			return (
				<div width="100%">
					<div className="dataHeaders">
						<span style={{ flex: '0 0 100px', cursor: 'pointer' }} onClick={this.sort} data-sortBy="name">Message</span>
						<span style={{ flex: '1 0 20%', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort} data-sortBy="modified">Verbiage</span>
					</div>
					<div style={{ overflow: 'auto', height: 'calc(100% - 85px)' }}>
						{fmList}
					</div>
					{editMessage}
				</div>
			);
		} else {
			return (
				<div width="100%">

				</div>
			);
		}
	}
}

const icon = "menuMic"
const roles = ["View", "Edit"]
export { FacilityMessages, icon, roles }